var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-avatar",style:({'--avatar-size': _vm.size + 'px'})},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl}}):_c('identicon',{attrs:{"id":_vm.identicon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }